import { APIClient } from "../../helpers/apiClient";
import {
  SET_ACTIVE_TAB,
  OPEN_USER_PROFILE_SIDEBAR,
  CLOSE_USER_PROFILE_SIDEBAR,
  SET_CONVERSATION_NAME_IN_OPEN_CHAT,
  OPEN_TEMPLATES_SIDEBAR,
  CLOSE_TEMPLATES_SIDEBAR,
  OPEN_SPERANT_EXTENSION_SIDEBAR,
  CLOSE_SPERANT_EXTENSION_SIDEBAR,
  OPEN_IA_ANALYSIS_SIDEBAR,
  CLOSE_IA_ANALYSIS_SIDEBAR,
  OPEN_ORDERS_SIDEBAR,
  CLOSE_ORDERS_SIDEBAR

} from "./constants";
import { setUserSidebarDefaultOpen, updateDataCurrentGroup } from "../actions";

const apiClient = new APIClient();

export const setActiveTab = (tabId) => ({
  type: SET_ACTIVE_TAB,
  payload: tabId,
});

export const openUserSidebar = () => ({
  type: OPEN_USER_PROFILE_SIDEBAR,
});

export const closeUserSidebar = () => ({
  type: CLOSE_USER_PROFILE_SIDEBAR,
});

export const setconversationNameInOpenChat = (conversationName) => ({
  type: SET_CONVERSATION_NAME_IN_OPEN_CHAT,
  payload: conversationName,
});

export const openTemplatesSidebar = () => ({
  type: OPEN_TEMPLATES_SIDEBAR,
});

export const closeTemplatesSidebar = () => ({
  type: CLOSE_TEMPLATES_SIDEBAR,
});

export const openSperantExtensionSidebar = () => ({
  type: OPEN_SPERANT_EXTENSION_SIDEBAR,
});

export const closeSperantExtensionSidebar = () => ({
  type: CLOSE_SPERANT_EXTENSION_SIDEBAR,
});

export const openIaAnalysisSidebar = () => ({
  type: OPEN_IA_ANALYSIS_SIDEBAR,
});

export const closeIaAnalysisSidebar = () => ({
  type: CLOSE_IA_ANALYSIS_SIDEBAR,
});

export const openOrdersSidebar = () => ({
  type: OPEN_ORDERS_SIDEBAR,
});

export const closeOrdersSidebar = () => ({
  type: CLOSE_ORDERS_SIDEBAR,
});

export const toggleUserSidebar = (isOpen) => async (dispatch, getState) => {
  try {
    const currentGroup = getState().Group.currentGroup;
    await apiClient.patch(`/groups/${currentGroup.id}/user-sidebar-open`, { isOpen: !!isOpen });
    const currentGroup_now = getState().Group.currentGroup;
    if (currentGroup_now.id !== currentGroup.id) return;

    if (isOpen) dispatch(openUserSidebar());
    else dispatch(closeUserSidebar());
    dispatch(setUserSidebarDefaultOpen(isOpen));
    dispatch(updateDataCurrentGroup({ ...currentGroup, isUserSidebarOpen: isOpen }));
  } catch (error) {
    console.error("Error setting user sidebar default open:", error);
  }
};
